import { CameraModeMask, CameraControl } from '@egr/wcf/modules/core/view/CameraControl';
import { ShadowGenerator } from "@egr/wcf/modules/core/rendering/ShadowGenerator";
import { CsgUtils } from "../CsgUtils";
import { ElementGeometry } from "./ElementGeometry";
import { RoomManager } from './../../RoomManager';
import { Util } from "../../utils/Util";
export class GeoMarker extends ElementGeometry {
    constructor(pRoomManager, pElement) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
    }
    getType() {
        return ("GeoMarker");
    }
    setMesh(pMesh) {
        //
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 0;
        tParams.depth = 0;
        tParams.height = 0;
        tParams.floorOffset = 0.0;
        tParams.color = "#ffffff";
        return (tParams);
    }
    updateMesh() {
        const tcol_active = this.mRoomManager.app.theme.mainColorBright;
        if (this.mMesh2d != null) {
            this.mMesh2d.scaling.x = this.mRoomElement.scaleFactor * GeoMarker.SCALEFAC;
            this.mMesh2d.scaling.z = this.mRoomElement.scaleFactor * GeoMarker.SCALEFAC;
            this.mMesh2d.renderingGroupId = 1;
            ShadowGenerator.disableMeshShadow(this.mMesh2d);
        }
        if (this.mMeshCircle != null) {
            this.mMeshCircle.scaling.x = this.mRoomElement.scaleFactor * GeoMarker.SCALEFAC;
            this.mMeshCircle.scaling.z = this.mRoomElement.scaleFactor * GeoMarker.SCALEFAC;
            this.mMeshCircle.renderingGroupId = 1;
            ShadowGenerator.disableMeshShadow(this.mMeshCircle);
        }
        if (this.mMesh3d != null) {
            this.mMesh3d.scaling.x = this.mRoomElement.scaleFactor * GeoMarker.SCALEFAC;
            this.mMesh3d.scaling.z = this.mRoomElement.scaleFactor * GeoMarker.SCALEFAC;
            this.mMesh3d.renderingGroupId = 1;
            ShadowGenerator.disableMeshShadow(this.mMesh3d);
        }
    }
    create2dGeometry(pParent) {
        this.mMesh2d = this.createGeoMarker(pParent);
    }
    create3dGeometry(pParent) {
        // this.mMesh3d = this.createGeoMarker(pParent);
    }
    createCSG(pParent) {
        // circle
        const tCAG_Circle = CAG.circle({ center: [0, 1.5], radius: 0.5, resolution: 16 });
        const tCAG_Circle_small = CAG.circle({ center: [0, 1.5], radius: 0.25, resolution: 16 });
        // triangle
        let tPoints = new Array();
        tPoints.push(new CSG.Vector2D(-0.47, 1.34));
        tPoints.push(new CSG.Vector2D(0, 0));
        tPoints.push(new CSG.Vector2D(0.47, 1.34));
        const tCAG_Triangle = CAG.fromPointsNoCheck(tPoints);
        let tCAG_Marker = tCAG_Circle.union(tCAG_Triangle);
        tCAG_Marker = tCAG_Marker.subtract(tCAG_Circle_small);
        const tCSG_Marker = Util.CAG2CSG(tCAG_Marker);
        const tCSG_Circle = Util.CAG2CSG(tCAG_Circle_small);
        const tm_Marker = CsgUtils.buildMeshes(tCSG_Marker, this.mScene);
        const tm_circle = CsgUtils.buildMeshes(tCSG_Circle, this.mScene);
        if (tm_Marker == null || tm_circle == null) {
            return (null);
        }
        for (let tMesh of tm_Marker) {
            tMesh.parent = pParent;
            tMesh.name = RoomManager.ROOM_SHAPE2D_PREFIX + 'BuildingBottomTop';
            tMesh.material = this.mRoomManager.mat_theme_bright;
            tMesh.scaling.x = this.mRoomElement.scaleFactor * GeoMarker.SCALEFAC;
            tMesh.scaling.z = this.mRoomElement.scaleFactor * GeoMarker.SCALEFAC;
            tMesh.position.y = 50;
            //not visible in top and bottom view
            CameraControl.SetMeshCameraModeMask(tMesh, CameraModeMask.All &
                ~CameraModeMask.Perspective);
        }
        for (let tMesh1 of tm_circle) {
            tMesh1.parent = pParent;
            tMesh1.name = RoomManager.ROOM_SHAPE2D_PREFIX + 'BuildingBottomTop';
            tMesh1.material = this.mRoomManager.mat_white;
            tMesh1.scaling.x = this.mRoomElement.scaleFactor * GeoMarker.SCALEFAC;
            tMesh1.scaling.z = this.mRoomElement.scaleFactor * GeoMarker.SCALEFAC;
            tMesh1.position.y = 50;
            //not visible in top and bottom view
            CameraControl.SetMeshCameraModeMask(tMesh1, CameraModeMask.All &
                ~CameraModeMask.Perspective);
        }
        this.mMeshCircle = tm_circle[0];
        return (tm_Marker[0]);
    }
    createGeoMarker(pParent) {
        let tMesh = this.createCSG(pParent);
        return (tMesh);
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
GeoMarker.SCALEFAC = 0.25;
